<template>
  <div class="position-relative mt-4 calendar-picker">
    <div
      class="disable-picker bg-med-light-gray is-disabled"
      v-if="disabled"
    ></div>
    <v-calendar
      title-position="left"
      locale="en"
      is-expanded
      :attributes="attributes"
      @dayclick="onDayClick"
      @transition-end="pageChanged"
      :available-dates="{
        start: new Date(minDate + ' 12:00'),
        end: new Date(maxDate + ' 12:00')
      }"
    />
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "CalendarPicker",
  props: ["value", "disabled", "minDate", "maxDate"],
  data() {
    return {
      days: []
    };
  },
  methods: {
    pageChanged() {
      let days = document.getElementsByClassName("vc-day-content");
      var minDate = new Date(this.minDate).getTime();
      var maxDate = new Date(this.maxDate + " 12:00").getTime();
      [...days]
        .filter(
          day =>
            new Date(day.ariaLabel).getTime() >= minDate &&
            new Date(day.ariaLabel).getTime() <= maxDate
        )
        .forEach(day => {
          day.classList.toggle("is-disabled", this.disabled);
        });
    },
    onDayClick(day) {
      let value = [...this.value];
      const idx = value.findIndex(d => d === day.id);
      if (idx >= 0) {
        value.splice(idx, 1);
      } else {
        value.push(day.id);
      }
      this.$emit("input", value);
    }
  },
  computed: {
    dates() {
      return this.value.map(day => moment(day).toDate());
    },
    attributes() {
      return this.dates.map(date => ({
        highlight: true,
        dates: date
      }));
    }
  },
  watch: {
    disabled: function() {
      this.pageChanged();
    }
  }
};
</script>

<style scoped>
.calendar-picker >>> .vc-container {
  background-color: transparent !important;
  border: none !important;
}
.disable-picker {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  opacity: 0.3;
}
div >>> .is-disabled {
  pointer-events: none;
}
</style>
